import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { applyCached } from "./appearanceContext";
import App from "./App.tsx";
import "./styles.css";

// Before the first render, so the login screen is already in the right theme.
applyCached();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
